<template>
  <div class="projectDetail">
    <div class="top position-relative">
      <div class="bgPic h-100"><img :src="info.poster" class="w-100 h-100 object-fit-cover"></div>
      <div class="mask"></div>
      <dl class="text mb-0">
          <div class="container-xxl px-4 position-relative">
            <dt>{{info.title}}</dt>
            <dd class="mb-0 d-flex flex-column flex-lg-row align-items-lg-end mt-3 mt-lg-5" v-if="info.cntitle">
              <span class="add">{{info.cntitle}}</span>
              <span class="mt-5 mt-lg-0 ms-lg-4 lh-1 place">{{info.place}}</span>
            </dd>
            <a href="javascript:" class="btn btn-secondary rounded-pill py-3 px-4 tkBtn" @click="showView()">
              <i class="bi bi-fullscreen"></i>
              <span class="ps-3">Gallery</span>
            </a>
          </div>
      </dl>
    </div>
    <div class="container-xxl p-4 py-lg-5" v-if="info.content">
      <div class="bot" v-html="info.content">
       
      </div>
    </div>

    <transition name="pic-detail">
      <div class="picModal bgA" ref="picModalView" v-show="showFlag">
        <a href="javascript:" class="closeBtn" @click="closeView"><i class="bi bi-x"></i></a>
        <div class="h-100">
          
          <swiper class="swiper gallery-top" :options="swiperOptionTop" ref="swiperTop">
            <swiper-slide v-for="(item,index) in info.video" :key="index + 100">
              <video :src="item" controls></video>
            </swiper-slide>
            <swiper-slide v-for="(item,index) in info.picture" :key="index">
              <img :src="item"> 
            </swiper-slide>
            <div class="swiper-button-next d-none d-lg-block" slot="button-next"></div>
            <div class="swiper-button-prev d-none d-lg-block" slot="button-prev"></div>
          </swiper>
          <!-- swiper2 Thumbs -->
          <!-- <swiper class="swiper gallery-thumbs" :options="swiperOptionThumbs" ref="swiperThumbs">
            <swiper-slide v-for="(item,index) in info.picture" :key="index">
              <img :src="item">
            </swiper-slide>
          </swiper> -->
        </div>
        <!-- <div class="h-100" v-show="info.video.length">
          <div class="gallery-top">
            <div class="swiper-slide" v-for="(item,index) in video" :key="index">
              <video :src="item" controls></video>
            </div>
          </div>
        </div> -->
      </div>
    </transition>
   
  </div>
</template>

<script>
import axios from '@/axios-auth'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import "swiper/css/swiper.min.css";

export default {
  name: 'ProjectDetail',
  
  components: {
    Swiper,
    SwiperSlide
  },
  // 
  data () {
    return {
      showFlag:false,
      id:this.$route.params.id - 1,
      type:this.$route.query.type,
      project:[],
      info:{},

      swiperOptionTop: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      // swiperOptionThumbs: {
      //   spaceBetween: 10,
      //   centeredSlides: true,
      //   slidesPerView: 'auto',
      //   touchRatio: 0.2,
      //   slideToClickedSlide: true
      // }

    }
  },
  methods:{
    showView(){
      this.showFlag = true 
      // console.log(this.video)
    },
    closeView(){
      this.showFlag = false 
    },
    // swiperUpdate(){
    //   const swiperTop = this.$refs.swiperTop.$swiper
    //   const swiperThumbs = this.$refs.swiperThumbs.$swiper
    //   swiperTop.slideTo(0, 0);
    //   swiperThumbs.slideTo(0, 0);


    // }
  },
  computed: {
   
  },
  created(){
    axios.get('/projects.json')
        .then( res => {
          return res.data
        })
        .then( response => {
          if(response.code == 0){
            this.project = response.data[this.type].list
            this.info = this.project[this.id]
          }
          console.log(this.info)
 
        
        })
  },
  mounted(){
    this.$nextTick(function(){
      // const swiperTop = this.$refs.swiperTop.$swiper
      // const swiperThumbs = this.$refs.swiperThumbs.$swiper
      // swiperTop.controller.control = swiperThumbs
      // swiperThumbs.controller.control = swiperTop

    })
  },
  
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .projectDetail .top{ height: calc(100vh - 60px);}
  .projectDetail .top .mask{background-color: rgba(0, 0, 0, .5); position: absolute; left: 50%; top: 50%; transform: translateX(-50%) translateY(-50%); width: 100%; height: 100%;}
  .projectDetail .top .text { color: #fff; position: absolute; left: 0; right: 0; bottom: 3rem;}
  .projectDetail .top .text dt{font-size: 30px; max-width: 80%;}
  .projectDetail .top .text .add{font-size: 15px;}
  .projectDetail .top .text .place{font-size: 13px; color: rgba(255, 255, 255, .7); letter-spacing: .075em;}
  .projectDetail .top .tkBtn{ position: absolute; right: 1.5rem; bottom: -1rem;}

  .pic-detail-enter-active, .pic-detail-leave-active {transition:  .3s}
  .pic-detail-enter, .pic-detail-leave-to {transform: translateX(100%);}

  .picModal{ position: fixed; left: 0; right: 0; top: 0; bottom: 0; z-index: 5000;}
  .picModal .closeBtn{ position: absolute; left: 15px; top: 20px; z-index: 5; width: 40px; height: 40px; text-align: center; line-height: 40px; font-size: 30px;}
  .gallery-top{ height: 100%;}
  .gallery-top img,.gallery-top video{ width: 100%; height: 100%; object-fit: contain;}
  .gallery-thumbs{ height: 100px; position: absolute; left: 0; bottom: 0; right: 0;}
  .gallery-thumbs img{ height: 100%;}
  .gallery-thumbs .swiper-slide{ width: auto; padding: 10px 0;}
  .swiper-button-next, .swiper-button-prev{ color: #000;}


  @media (min-width: 576px) {
    .indexPro li a{ height: 350px;}
  }

  @media (min-width: 768px) {
    /* .gallery-top{ height: calc(100% - 5vw);} */
    .gallery-top .swiper-slide{ padding: 5%;}
    .gallery-thumbs { height: 5vw;  padding-bottom: 1.5vw;}
    .gallery-thumbs .swiper-slide{ padding: 0;}
  }

  @media (min-width: 992px) {
    .projectDetail .top{ height: calc(100vh - 80px);}
    .projectDetail .top .text dt{font-size: 50px; max-width: 70%;}
    .projectDetail .top .text .add{ font-size: 1.25vw; line-height: 1;}
  
    .projectDetail .bot{ max-width: 70%;}

  }

  @media (min-width: 1200px) {
    
  }

  @media (min-width: 1400px) {
    .indexPro li a{ height: 500px; }
    .indexPro dt{ font-size: 18px;}
    .indexPro dd{ font-size: 18px;}
  }
</style>



// WEBPACK FOOTER //
// src/components/projects/Detail.vue